import React, { useState, useEffect, useCallback } from "react";
import { useNavigate, useLocation } from "react-router-dom";
import "../css/Sidebar.css";

const Sidebar = ({ isOpen, onClose }) => {
  const navigate = useNavigate();
  const location = useLocation();

  // Move menuItems definition here
  const menuItems = [
    {
      id: "dashboard",
      label: "Dashboard",
      icon: "📊",
      path: "/dashboard",
    },
    {
      id: "category",
      label: "Category",
      icon: "🏷️",
      hasSubmenu: true,
      submenu: [
        {
          id: "add-category",
          label: "Add Category",
          path: "/add-category",
        },
        {
          id: "category-list",
          label: "Category List",
          path: "/category-list",
        },
      ],
    },
    {
      id: "menu",
      label: "Menu",
      icon: "📋",
      hasSubmenu: true,
      submenu: [
        {
          id: "add-menu",
          label: "Add Menu",
          path: "/add-menu",
        },
        {
          id: "menu-list",
          label: "Menu List",
          path: "/menu-list",
        },
      ],
    },
    {
      id: "users",
      label: "Users",
      icon: "👥",
      hasSubmenu: true,
      submenu: [
        {
          id: "add-user",
          label: "Add User",
          path: "/add-user",
        },
        {
          id: "user-list",
          label: "User List",
          path: "/user-list",
        },
      ],
    },
    {
      id: "table",
      label: "Table",
      icon: "🍽️",
      hasSubmenu: true,
      submenu: [
        {
          id: "add-table",
          label: "Add Table",
          path: "/add-table",
        },
        {
          id: "table-list",
          label: "Table List",
          path: "/table-list",
        },
      ],
    },
    {
      id: "chair",
      label: "Chair",
      icon: "🪑",
      hasSubmenu: true,
      submenu: [
        {
          id: "add-chair",
          label: "Add Chair",
          path: "/add-chair",
        },
        {
          id: "chair-list",
          label: "Chair List",
          path: "/chair-list",
        },
      ],
    },
    {
      id: "unit",
      label: "Unit",
      icon: "📏",
      hasSubmenu: true,
      submenu: [
        {
          id: "add-unit",
          label: "Add Unit",
          path: "/add-unit",
        },
        {
          id: "unit-list",
          label: "Unit List",
          path: "/unit-list",
        },
      ],
    },
    {
      id: "product",
      label: "Product",
      icon: "📦",
      hasSubmenu: true,
      submenu: [
        {
          id: "add-product",
          label: "Add Product",
          path: "/add-product",
        },
        {
          id: "product-list",
          label: "Product List",
          path: "/product-list",
        },
      ],
    },
    
    {
      id: "department",
      label: "Department",
      icon: "👳‍♂️",
      hasSubmenu: true,
      submenu: [
        {
          id: "add-department",
          label: "Add department",
          path: "/add-department",
        },
        {
          id: "department-list",
          label: "Department List",
          path: "/department-list",
        },
        {
          id: "add-department-discount",
          label: "Add department discount",
          path: "/add-department-discount",
        },
        {
          id: "department-discount-list",
          label: "Department discount List",
          path: "/department-discount-list",
        },
        {
          id: "add-department-customer",
          label: "Add department customer",
          path: "/add-department-customer",
        },
        {
          id: "department-customer-list",
          label: "Department customer List",
          path: "/department-customer-list",
        },
      
      ],
    },
    {
      id: "room",
      label: "Room",
      icon: "🏠",
      hasSubmenu: true,
      submenu: [
        {
          id: "add-room",
          label: "Add room",
          path: "/add-room",
        },
        {
          id: "room-list",
          label: "Room List",
          path: "/room-list",
        },
        {
          id: "add-room-type",
          label: "Add room type",
          path: "/add-room-type",
        },
        {
          id: "room-type-list",
          label: "Room type list",
          path: "/room-type-list",
        },
        {
          id: "add-room-booking",
          label: "Add room booking",
          path: "/add-room-booking",
        },
        {
          id: "room-booking-list",
          label: "Room booking list",
          path: "/room-booking-list",
        },
        {
          id: "room-booking-report",
          label: "Room booking report",
          path: "/room-booking-report",
        },
       
      ],
    },
    {
      id: "bed",
      label: "Bed",
      icon: "🛏️",
      hasSubmenu: true,
      submenu: [
        {
          id: "add-bed",
          label: "Add bed",
          path: "/add-bed",
        },
        {
          id: "bed-list",
          label: "Bed list",
          path: "/bed-list",
        },
      ],
    },
    {
      id: "supplier",
      label: "Supplier",
      icon: "👨‍🎨",
      hasSubmenu: true,
      submenu: [
        {
          id: "add-supplier",
          label: "Add Supplier",
          path: "/add-supplier",
        },
        {
          id: "supplier-list",
          label: "Supplierg list",
          path: "/supplier-list",
        },
      
      ],
    },
    {
      id: "purchase",
      label: "Purchase",
      icon: "🛒",
      hasSubmenu: true,
      submenu: [
        {
          id: "add-purchase",
          label: "Add purchase",
          path: "/add-purchase",
        },
        {
          id: "purchase-list",
          label: "Purchase list",
          path: "/purchase-list",
        },
        {
          id: "purchase-report",
          label: "Purchase Report",
          path: "/purchase-report",
        }
      ],
    },
    {
      id: "sales",
      label: "Sales",
      icon: "🛍️",
      hasSubmenu: true,
      submenu: [
        {
          id: "add-sales",
          label: "Add sale",
          path: "/add-sale",
        },
        {
          id: "sales-list",
          label: "Sales history",
          path: "/sale-history",
        },
        {
          id: "sales-report-new",
          label: "Sales Report",
          path: "/sales-report-new",
        }
      
      ],
    },
    {
      id: "Asset",
      label: "Asset",
      icon: "📁",
      hasSubmenu: true,
      submenu: [
        {
          id: "add-asset",
          label: "Add asset",
          path: "/add-asset",
        },
        {
          id: "asset-list",
          label: "Asset list",
          path: "/asset-list",
        },
      ],
    },
    // add expense
    {
      id: "expense",
      label: "Expense",
      icon: "💰",
      hasSubmenu: true,
      submenu: [
        {
          id: "add-expense",
          label: "Add expense",
          path: "/add-expense",
        },
        {
          id: "expense-list",
          label: "Expense list",
          path: "/expense-list",
        },
      ],
    },
    {
      id: "sales-report",
      label: "Sales report",
      icon: "📊",
      path: "/sales-report",
    },
   
  ];

  // Helper to determine which submenus should be open based on current route
  const getInitialSubmenuOpen = useCallback(() => {
    const open = {};
    menuItems.forEach((item) => {
      if (item.hasSubmenu && item.submenu) {
        open[item.id] = item.submenu.some(
          (subItem) => location.pathname === subItem.path
        );
      }
    });
    return open;
  }, [location.pathname]);

  const [activeMenu, setActiveMenu] = useState("dashboard");
  const [submenuOpen, setSubmenuOpen] = useState(getInitialSubmenuOpen);

  // Keep submenu open in sync with route changes
  useEffect(() => {
    setSubmenuOpen(getInitialSubmenuOpen());
  }, [getInitialSubmenuOpen]);

  const handleNavigation = (path) => {
    navigate(path);
    if (onClose) onClose();
  };

  const toggleSubmenu = (menu) => {
    setSubmenuOpen((prev) => ({
      ...prev,
      [menu]: !prev[menu],
    }));
  };

  const renderForm = (item) => {
    if (!item.hasForm) return null;

    return (
      <div className="form-container">
        <h3>{item.label}</h3>
        <form className="menu-form">
          {item.formFields.map((field, index) => (
            <div key={index} className="form-group">
              <label htmlFor={field.name}>{field.label}</label>
              {field.type === "select" ? (
                <select id={field.name} name={field.name}>
                  <option value="">Select {field.label}</option>
                  {field.options.map((option, optIndex) => (
                    <option key={optIndex} value={option}>
                      {option}
                    </option>
                  ))}
                </select>
              ) : (
                <input
                  type={field.type}
                  id={field.name}
                  name={field.name}
                  placeholder={field.placeholder}
                />
              )}
            </div>
          ))}
          <button type="submit" className="submit-btn">
            Submit
          </button>
        </form>
      </div>
    );
  };

  const isActiveMenu = (item) => {
    if (item.path) {
      return location.pathname === item.path;
    }
    if (item.hasSubmenu && item.submenu) {
      return item.submenu.some((subItem) => location.pathname === subItem.path);
    }
    return activeMenu === item.id;
  };

  return (
    <aside className={`dashboard-sidebar ${isOpen ? "open" : ""}`}>
      <nav className="sidebar-nav">
        {menuItems.map((item) => (
          <div key={item.id} className="nav-item-wrapper">
            {item.hasSubmenu ? (
              <div className="nav-item-with-submenu">
                <button
                  className={`nav-item ${isActiveMenu(item) ? "active" : ""}`}
                  onClick={() => {
                    setActiveMenu(item.id);
                    toggleSubmenu(item.id);
                  }}
                >
                  <span className="nav-icon">{item.icon}</span>
                  <span className="nav-label">{item.label}</span>
                  <span
                    className={`submenu-arrow ${
                      submenuOpen[item.id] ? "open" : ""
                    }`}
                  >
                    ▼
                  </span>
                </button>

                {submenuOpen[item.id] && (
                  <div className="submenu">
                    {item.submenu.map((subItem) => (
                      <div key={subItem.id} className="submenu-item-wrapper">
                        <button
                          className={`submenu-item ${
                            isActiveMenu(subItem) ? "active" : ""
                          }`}
                          onClick={() => {
                            setActiveMenu(subItem.id);
                            if (subItem.path) {
                              handleNavigation(subItem.path);
                            }
                          }}
                        >
                          <span className="nav-label">{subItem.label}</span>
                        </button>
                        {subItem.hasForm &&
                          isActiveMenu(subItem) &&
                          renderForm(subItem)}
                      </div>
                    ))}
                  </div>
                )}
              </div>
            ) : (
              <div className="nav-item-wrapper">
                <button
                  className={`nav-item ${isActiveMenu(item) ? "active" : ""}`}
                  onClick={() => {
                    setActiveMenu(item.id);
                    if (item.path) {
                      handleNavigation(item.path);
                    }
                  }}
                >
                  <span className="nav-icon">{item.icon}</span>
                  <span className="nav-label">{item.label}</span>
                </button>
                {item.hasForm && isActiveMenu(item) && renderForm(item)}
              </div>
            )}
          </div>
        ))}
      </nav>
    </aside>
  );
};

export default Sidebar;
